/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: David Helmick
 * @ Modified time: 2024-06-11 18:00:48
 * @ Description: Card showing monthly limit, when limit resets, and option to change plans
 */

import React from 'react'
import { Button, Card, Box } from '@mui/material'

// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'

import { CircularProgressbar } from 'react-circular-progressbar'
import { useMutation } from '@apollo/client/react'
import { CREATE_SESSION } from '../mutations'
import withSession from '@/housefolios-components/Session/withSession'
import useAffiliate from '@/hooks/useAffiliate'

function MonthlyLimitComponent(props) {
  const [createBillingPortalSession] = useMutation(CREATE_SESSION)

  const changePlan = async () => {
    var session = await createBillingPortalSession()

    window.open(
      session.data.createBillingPortalSession.url,
      '_blank',
      '',
    )
  }

  const [{ affiliate, affiliateLoading, urlAffiliate }] =
    useAffiliate({
      memberValue: props?.session?.me?.activeOrg?.member,
    })

  var today = new Date()
  var resetDate = !isEmpty(props.session.me.activeOrg.subscriptions)
    ? props.session.me.activeOrg.subscriptions[0].current_period_end
      ? new Date(
          props.session.me.activeOrg.subscriptions[0]
            .current_period_end * 1000,
        )
      : null
    : props.session.me.activeOrg.parentCorp &&
        !isEmpty(props.session.me.activeOrg.parentCorp.subscriptions)
      ? props.session.me.activeOrg.parentCorp.subscriptions[0]
          .current_period_end
        ? new Date(
            props.session.me.activeOrg.parentCorp.subscriptions[0]
              .current_period_end * 1000,
          )
        : null
      : !isEmpty(
            props?.session?.me?.activeOrg
              ?.memberProvidedSubscriptions,
          )
        ? props?.session?.me?.activeOrg
            ?.memberProvidedSubscriptions[0].current_period_end
          ? new Date(
              props?.session?.me?.activeOrg
                ?.memberProvidedSubscriptions[0].current_period_end *
                1000,
            )
          : null
        : null
  if (!resetDate) {
    var month = today.getMonth()
    resetDate = new Date()
    if (month === 11) {
      resetDate.setFullYear(resetDate.getFullYear() + 1, 0, 1)
    } else resetDate.setMonth(month + 1, 1)
  }
  if (
    (resetDate.getFullYear() > today.getFullYear() &&
      (today.getMonth() !== 11 || resetDate.getMonth() !== 0)) ||
    resetDate.getMonth() > today.getMonth() + 1 ||
    resetDate.getMonth() === today.getMonth() + 1 ||
    resetDate.getDate() > today.getDate()
  ) {
    if (resetDate.getDate() > today.getDate()) {
      resetDate.setFullYear(today.getFullYear(), today.getMonth())
      if (resetDate.getMonth() !== today.getMonth())
        resetDate.setDate(0)
    } else {
      resetDate.setFullYear(today.getFullYear(), today.getMonth() + 1)
      if (
        resetDate.getMonth() !== today.getMonth() + 1 &&
        resetDate.getMonth() !== 0
      )
        resetDate.setDate(0)
    }
  }
  const timeToReset = resetDate - today
  const daysToReset = Math.floor(timeToReset / 1000 / 60 / 60 / 24)
  return (
    <Card variant="outlined"
     
      sx={{ width: '100%', display: 'flex', alignItems: 'center' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', px: '1.5rem', pt: '1.5rem', pb: '0.5rem', }}>
          <Box component="h6" sx={[{ fontWeight: 700, mb: '0.25rem' }, {
            fontSize: "1.265rem !important",
            color: "#070919",
            "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
          }]}>
            Monthly Limit
          </Box>
        </Box>
        <Box sx={{ mx: 'auto' }}>
          <CircularProgressbar value={ (props.session.me.activeOrg.propertyCount.monthlyCount / props.session.me.limits.propertyLimit) * 100 }
            text={ props.session.me.activeOrg.propertyCount.monthlyCount + '/' + Number(props.session.me.limits.propertyLimit) }
            strokeWidth={8} sx={[{ m: '1rem' }, {
              width: 180,
              "& .CircularProgressbar-path": { stroke: "#368cff" },
              "& .CircularProgressbar-trail": { stroke: "rgba(54, 140, 255, 0.1)" },
              "& .CircularProgressbar-text": { fill: "#368cff" },
              "& .CircularProgressbar-background": { fill: "rgba(54, 140, 255, 0.05)" },
            }]} />
        </Box>
        {!isEmpty(props.session.me.activeOrg.subscriptions) && (
          <Box
            component="p"
            data-hf="muted"
            sx={{
              mb: '1rem',
              color: 'rgba(7, 9, 25, 0.5)',
              textAlign: 'center',
              'html[data-color-mode="dark"] &': {
                color: 'rgba(255, 255, 255, 0.68) !important',
              },
            }}
          >
            Limit resets in {daysToReset} days
          </Box>
        )}
        {(props.session.me.subscriptionPlan ===
          'enterprise-affiliate' &&
          props.page === 'launchpad') ||
        urlAffiliate ? (
          <></>
        ) : (
          <Box sx={{ px: '1.5rem', pb: '1.5rem', pt: '0.5rem' }}>
            <Button onClick={ isEmpty(props.session.me.activeOrg.subscriptions) ? props.toggleSubscribe : changePlan } fullWidth sx={[{
              backgroundColor: "rgba(79, 80, 98, 0.15)",
              color: "#4f5062",
              borderColor: "transparent",
              "&:hover, &.active": { backgroundColor: "#4f5062", color: "#fff" },
              "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
              "html[data-color-mode=\"dark\"] &": { background: "rgba(255, 255, 255, 0.08) !important", color: "rgba(255, 255, 255, 0.92) !important" },
              transition: "all 0.2s ease-in-out !important",
              transform: "scale(1) !important",
              position: "relative",
              zIndex: "0",
              "&:hover": { transform: "scale(1.08)", zIndex: 3 },
              fontWeight: 700,
              textTransform: "uppercase",
            }, { fontSize: "0.875rem !important" }]}>
              Manage Plan
            </Button>
          </Box>
        )}
      </Box>
    </Card>
  )
}

export default withSession(MonthlyLimitComponent)
